import { render, staticRenderFns } from "./GroupStructure.vue?vue&type=template&id=3bc51ecb&"
import script from "./GroupStructure.vue?vue&type=script&lang=js&"
export * from "./GroupStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports